import { WorkflowApproval } from "../chat-widgets/approval-card/workflow-apporval.model";
import { AppUser } from "../users/user.model";
import { MessageSegment } from "./message-segment.model";

export class ChatMessage {
    messageId?: number;
    requestMessageId?: number;
    success: boolean = true;
    isPartial: boolean = true;
    sessionId: number | undefined;
    sender: AppUser;
    origTextContent?: string;
    textContent: string;
    chartContent?: any;
    taskContent?: any;
    tableContent?: any;
    activeCanvasPath?: string;
    fileUrlContent?: string;
    fileNameContent?: string;
    businessObject?: BusinessObject;
    workflowApprovals?: WorkflowApproval[];
    timestamp: Date;
    segments?: MessageSegment[]; // For rich content rendering

    constructor(messageText: string, sender: AppUser, sessionId: number) {
        this.sender = sender;
        this.origTextContent = messageText;
        this.textContent = messageText;
        this.sessionId = sessionId;
        this.timestamp = new Date();
    }
}

export class BusinessObject {
    objectId?: number;
    objectType?: string;
    objectName?: string;
    objectDescription?: string;
  
    constructor(data?: Partial<BusinessObject>) {
      if (data) {
        Object.assign(this, data);
      }
    }
  }